import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-skills-certificate-type',
  templateUrl: './skills-certificate-type.component.html',
  styleUrls: ['./skills-certificate-type.component.css']
})
export class SkillsCertificateTypeComponent implements OnInit {
    skillsCertificateTypeKeyno;

    public glyphiconButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-left', goto: 'selectglyphicon' }];

    public edit?: Edit;

    public selectListGlyphicons: Item[] = [];

    public selectListHexColours: HexColourItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.skillsCertificateTypeKeyno = this.stateService.getStateParams()['skillscertificatetype_keyno'];
    }

    private async loadEdit() {
        if (!!this.skillsCertificateTypeKeyno) {
            this.edit = (await this.datatask.Post(2499, { skillscertificatetype_keyno: this.skillsCertificateTypeKeyno }))[0];
        }
    }

    private async loadGlyphicons() {
        this.selectListGlyphicons = await this.datatask.Post(1270);
    }

    private async loadHexColours() {
        this.selectListHexColours = await this.datatask.Post(491);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2500, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async showGlyphiconSymbol() {
        if (!this.edit) return;

        const glyph = this.selectListGlyphicons.find((item?: Item) => item?.item_id === this.edit?.glyphicon);

        if (glyph) {
            this.edit!.glyphicon = glyph.item_glyphicon ?? '';
        }
    }

    private async showColour() {
        if (!this.edit) return;

        const hex = this.selectListHexColours.find((item?: HexColourItem) => item?.hexcolor === this.edit?.glyphicon_color);

        if (hex) {
            this.edit.glyphicon_color = hex.hexcolor ?? '';
        }
    }

    public async onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'glyphicon':
            case 'glyphicon_color':
                await this.showGlyphiconSymbol();
                this.showColour();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadGlyphicons();
        this.loadHexColours();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    skillscertificatetype_keyno: string;
    skillscertificatetype_name: string;
    skillscertificatetype_shortname: string;
    note: string;
    order: string;
    glyphicon: string;
    glyphicon_color: string;
}

interface HexColourItem {
    hexcolor: string;
    color_name: string;
    orderby: number;
}
